
import FreeFormsFormFieldName from '@/components/free-forms/form-fields/name.vue'
import FreeFormsFormFieldSlug from '@/components/free-forms/form-fields/slug.vue'
import FreeFormsFormFieldIsFormEnabled from '@/components/free-forms/form-fields/is-form-enabled.vue'
import FreeFormsFormFieldDescriptionTranslationSelect from '@/components/free-forms/form-fields/description-translation-select.vue'
import FreeFormsFormFieldSubscriptionType from '@/components/free-forms/form-fields/subscription-type.vue'
import FreeFormsFormFieldProcessType from '@/components/free-forms/form-fields/process-type.vue'
import FreeFormsFormFieldAccessAllowed from '@/components/free-forms/form-fields/access-allowed.vue'
import FormFieldPackages from '@/components/_shared/form-fields/packages.vue'
import FreeFormsFormFieldSubscriptionEndDate from '@/components/free-forms/form-fields/subscription-end-date.vue'
import FreeFormsFormFieldSubscriptionAccessDuration from '@/components/free-forms/form-fields/subscription-access-duration.vue'
import FreeFormsFormFieldAccessDurationType from '@/components/free-forms/form-fields/access-duration-type.vue'

import { defineComponent, PropType, reactive, ref } from 'vue'
import { AddFreeForm } from '@/modules/free-forms/types'
import { useFreeFormsModule } from '@/modules/free-forms'
import QForm from 'quasar/src/components/form/QForm.js';
import { useFormModule } from '@/modules/_shared/forms'
import { FreeFormsRouteNames } from '@/router/routes-names'
import { useRouter, useRoute } from 'vue-router'

export default defineComponent({
    name: 'free-forms-new-free-form',
    components: {
        FreeFormsFormFieldName,
        FreeFormsFormFieldSlug,
        FreeFormsFormFieldIsFormEnabled,
        FreeFormsFormFieldDescriptionTranslationSelect,
        FreeFormsFormFieldSubscriptionType,
        FreeFormsFormFieldProcessType,
        FreeFormsFormFieldAccessAllowed,
        FormFieldPackages,
        FreeFormsFormFieldSubscriptionEndDate,
        FreeFormsFormFieldSubscriptionAccessDuration,
        FreeFormsFormFieldAccessDurationType
    },
    props: {
        modelValue: {
            type: Object as PropType<AddFreeForm>,
            required: true
        }
    },
    async setup () {
        const router = useRouter()
        const route = useRoute()
        const { addFreeForm } = useFreeFormsModule()
        const { submitForm, createOnSuccess } = useFormModule()
        const accessDurationTypeModel = ref('accessAfterDays')

        const form = ref<QForm>()
        const freeFormModel = reactive<AddFreeForm & { accessDurationTypeModel: string }>({
            name: '',
            descriptionTranslation: '',
            slug: '',
            isEnabled: true,
            subscriptionType: 'trial',
            processType: 'sales',
            accessAfterDays: 0,
            packages: [],
            accessDuration: null,
            endDate: null,
            accessDurationTypeModel: ''
        })

        const sendRequest = async () => {
            const processedFreeForm = {
                ...freeFormModel,
                accessAfterDays: +freeFormModel.accessAfterDays,
                accessDuration: freeFormModel.accessDuration ? +freeFormModel.accessDuration : null
            }
            const { accessDurationTypeModel, ...freeFormRequest } = processedFreeForm
            return addFreeForm(freeFormRequest)
        }
        const moveToList = () => router.push({ name: FreeFormsRouteNames.LIST, query: { page: route.query.page } })

        const onSubmit = () => submitForm(
            form.value,
            sendRequest,
            createOnSuccess('Free form added!')
        ).then(moveToList)

        return {
            freeFormModel,
            onSubmit,
            form,
            FreeFormsRouteNames,
            accessDurationTypeModel,
            route
        }
    }
})
